export const isAlpha = (value: string, ignoreSpaces?: boolean) => {
  if (ignoreSpaces) {
    value = value.replace(/\s/g, '');
  }

  const regex = /^[A-Z]+$/i;

  return regex.test(value);
};

export const isAlphanumeric = (value: string, ignoreSpaces?: boolean) => {
  if (ignoreSpaces) {
    value = value.replace(/\s/g, '');
  }

  const regex = /^[0-9A-Z]+$/i;

  return regex.test(value);
};

export const isLowercase = (value: string) => value === value.toLowerCase();
